import * as core from '../../../../../../../core'

import { query } from './policy-explorer-table.query'

export const RESOURCE = {
  payload: {
    alias: 'policies.policy-explorer-table',
    description:
      'Table of Policy Areas that drills down to the Policies in an area. ' +
      'The Policy Assistant can be opened for one policy, every policy in an ' +
      'area, or all policies, authorized to retrieve those policy documents ' +
      'for the duration of the session',
    name: 'Policies - Policy Explorer Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
